("function" != typeof lazySizes && "object" != typeof lazySizes || "undefined" == typeof lazySizes) && (function(t, e) {
	var i = e(t, t.document);
	t.lazySizes = i, "object" == typeof module && module.exports && (module.exports = i)
}(window, function(t, e) {
	"use strict";
	if (e.getElementsByClassName) {
		var i, a, s, r, l, o, n, c, p, d, u, f, m, g, b, y, h, v, w, $, x, T, z, A, _, k, C, L, P, S, D, E, H, M, I, q, O, j, N, F, R, B, U, W, G, V, Q, X = e.documentElement,
			K = t.Date,
			J = t.HTMLPictureElement,
			Y = "addEventListener",
			Z = "getAttribute",
			tt = t[Y],
			te = t.setTimeout,
			ti = t.requestAnimationFrame || te,
			ta = t.requestIdleCallback,
			ts = /^picture$/i,
			tr = ["load", "error", "lazyincluded", "_lazyloaded"],
			tl = {},
			to = Array.prototype.forEach,
			tn = function(t, e) {
				return tl[e] || (tl[e] = RegExp("(\\s|^)" + e + "(\\s|$)")), tl[e].test(t[Z]("class") || "") && tl[e]
			},
			tc = function(t, e) {
				tn(t, e) || t.setAttribute("class", (t[Z]("class") || "").trim() + " " + e)
			},
			tp = function(t, e) {
				var i;
				(i = tn(t, e)) && t.setAttribute("class", (t[Z]("class") || "").replace(i, " "))
			},
			td = function(t, e, i) {
				var a = i ? Y : "removeEventListener";
				i && td(t, e), tr.forEach(function(i) {
					t[a](i, e)
				})
			},
			tu = function(t, i, a, s, r) {
				var l = e.createEvent("Event");
				return a || (a = {}), a.instance = c, l.initEvent(i, !s, !r), l.detail = a, t.dispatchEvent(l), l
			},
			tf = function(e, i) {
				var a;
				!J && (a = t.picturefill || p.pf) ? (i && i.src && !e[Z]("srcset") && e.setAttribute("srcset", i.src), a({
					reevaluate: !0,
					elements: [e]
				})) : i && i.src && (e.src = i.src)
			},
			tm = function(t, e) {
				return (getComputedStyle(t, null) || {})[e]
			},
			tg = function(t, e, i) {
				for (i = i || t.offsetWidth; i < p.minSize && e && !t._lazysizesWidth;) i = e.offsetWidth, e = e.parentNode;
				return i
			},
			tb = (r = [], l = s = [], o = function() {
				var t = l;
				for (l = s.length ? r : s, i = !0, a = !1; t.length;) t.shift()();
				i = !1
			}, (n = function(t, s) {
				i && !s ? t.apply(this, arguments) : (l.push(t), a || (a = !0, (e.hidden ? te : ti)(o)))
			})._lsFlush = o, n),
			ty = function(t, e) {
				return e ? function() {
					tb(t)
				} : function() {
					var e = this,
						i = arguments;
					tb(function() {
						t.apply(e, i)
					})
				}
			},
			th = function(t) {
				var e, i = 0,
					a = p.throttleDelay,
					s = p.ricTimeout,
					r = function() {
						e = !1, i = K.now(), t()
					},
					l = ta && s > 49 ? function() {
						ta(r, {
							timeout: s
						}), s !== p.ricTimeout && (s = p.ricTimeout)
					} : ty(function() {
						te(r)
					}, !0);
				return function(t) {
					var r;
					(t = !0 === t) && (s = 33), e || (e = !0, (r = a - (K.now() - i)) < 0 && (r = 0), t || r < 9 ? l() : te(l, r))
				}
			},
			tv = function(t) {
				var e, i, a = function() {
						e = null, t()
					},
					s = function() {
						var t = K.now() - i;
						t < 99 ? te(s, 99 - t) : (ta || a)(a)
					};
				return function() {
					i = K.now(), e || (e = te(s, 99))
				}
			};
		! function() {
			var e, i = {
				lazyClass: "lazyload",
				loadedClass: "lazyloaded",
				loadingClass: "lazyloading",
				preloadClass: "lazypreload",
				errorClass: "lazyerror",
				autosizesClass: "lazyautosizes",
				srcAttr: "data-src",
				srcsetAttr: "data-srcset",
				sizesAttr: "data-sizes",
				minSize: 40,
				customMedia: {},
				init: !0,
				expFactor: 1.5,
				hFac: .8,
				loadMode: 2,
				loadHidden: !0,
				ricTimeout: 0,
				throttleDelay: 125
			};
			for (e in p = t.lazySizesConfig || t.lazysizesConfig || {}, i) e in p || (p[e] = i[e]);
			t.lazySizesConfig = p, te(function() {
				p.init && t8()
			})
		}();
		var tw = (T = /^img$/i, z = /^iframe$/i, A = "onscroll" in t && !/(gle|ing)bot/.test(navigator.userAgent), _ = 0, k = 0, C = 0, L = -1, P = function(t) {
				C--, t && !(C < 0) && t.target || (C = 0)
			}, S = function(t) {
				return null == x && (x = "hidden" == tm(e.body, "visibility")), x || "hidden" != tm(t.parentNode, "visibility") && "hidden" != tm(t, "visibility")
			}, D = function(t, i) {
				var a, s = t,
					r = S(t);
				for (h -= i, $ += i, v -= i, w += i; r && (s = s.offsetParent) && s != e.body && s != X;)(r = (tm(s, "opacity") || 1) > 0) && "visible" != tm(s, "overflow") && (r = w > (a = s.getBoundingClientRect()).left && v < a.right && $ > a.top - 1 && h < a.bottom + 1);
				return r
			}, H = th(E = function() {
				var t, i, a, s, r, l, o, n, f, g, T, z, P = c.elements;
				if ((m = p.loadMode) && C < 8 && (t = P.length)) {
					for (i = 0, L++; i < t; i++)
						if (P[i] && !P[i]._lazyRace) {
							if (!A || c.prematureUnveil && c.prematureUnveil(P[i])) F(P[i]);
							else if ((n = P[i][Z]("data-expand")) && (l = 1 * n) || (l = k), g || (g = !p.expand || p.expand < 1 ? X.clientHeight > 500 && X.clientWidth > 500 ? 500 : 370 : p.expand, c._defEx = g, T = g * p.expFactor, z = p.hFac, x = null, k < T && C < 1 && L > 2 && m > 2 && !e.hidden ? (k = T, L = 0) : k = m > 1 && L > 1 && C < 6 ? g : _), f !== l && (b = innerWidth + l * z, y = innerHeight + l, o = -1 * l, f = l), ($ = (a = P[i].getBoundingClientRect()).bottom) >= o && (h = a.top) <= y && (w = a.right) >= o * z && (v = a.left) <= b && ($ || w || v || h) && (p.loadHidden || S(P[i])) && (u && C < 3 && !n && (m < 3 || L < 4) || D(P[i], l))) {
								if (F(P[i]), r = !0, C > 9) break
							} else !r && u && !s && C < 4 && L < 4 && m > 2 && (d[0] || p.preloadAfterLoad) && (d[0] || !n && ($ || w || v || h || "auto" != P[i][Z](p.sizesAttr))) && (s = d[0] || P[i])
						} s && !r && F(s)
				}
			}), I = ty(M = function(t) {
				var e = t.target;
				if (e._lazyCache) return void delete e._lazyCache;
				P(t), tc(e, p.loadedClass), tp(e, p.loadingClass), td(e, q), tu(e, "lazyloaded")
			}), q = function(t) {
				I({
					target: t.target
				})
			}, O = function(t, e) {
				try {
					t.contentWindow.location.replace(e)
				} catch (i) {
					t.src = e
				}
			}, j = function(t) {
				var e, i = t[Z](p.srcsetAttr);
				(e = p.customMedia[t[Z]("data-media") || t[Z]("media")]) && t.setAttribute("media", e), i && t.setAttribute("srcset", i)
			}, N = ty(function(t, e, i, a, s) {
				var r, l, o, n, c, d;
				(c = tu(t, "lazybeforeunveil", e)).defaultPrevented || (a && (i ? tc(t, p.autosizesClass) : t.setAttribute("sizes", a)), l = t[Z](p.srcsetAttr), r = t[Z](p.srcAttr), s && (n = (o = t.parentNode) && ts.test(o.nodeName || "")), d = e.firesLoad || "src" in t && (l || r || n), c = {
					target: t
				}, tc(t, p.loadingClass), d && (clearTimeout(f), f = te(P, 2500), td(t, q, !0)), n && to.call(o.getElementsByTagName("source"), j), l ? t.setAttribute("srcset", l) : r && !n && (z.test(t.nodeName) ? O(t, r) : t.src = r), s && (l || n) && tf(t, {
					src: r
				})), t._lazyRace && delete t._lazyRace, tp(t, p.lazyClass), tb(function() {
					var e = t.complete && t.naturalWidth > 1;
					d && !e || (e && tc(t, "ls-is-cached"), M(c), t._lazyCache = !0, te(function() {
						"_lazyCache" in t && delete t._lazyCache
					}, 9)), "lazy" == t.loading && C--
				}, !0)
			}), F = function(t) {
				if (!t._lazyRace) {
					var e, i = T.test(t.nodeName),
						a = i && (t[Z](p.sizesAttr) || t[Z]("sizes")),
						s = "auto" == a;
					(!s && u || !i || !t[Z]("src") && !t.srcset || t.complete || tn(t, p.errorClass) || !tn(t, p.lazyClass)) && (e = tu(t, "lazyunveilread").detail, s && t$.updateElem(t, !0, t.offsetWidth), t._lazyRace = !0, C++, N(t, e, s, a, i))
				}
			}, R = tv(function() {
				p.loadMode = 3, H()
			}), B = function() {
				3 == p.loadMode && (p.loadMode = 2), R()
			}, U = function() {
				if (!u) {
					if (K.now() - g < 999) return void te(U, 999);
					u = !0, p.loadMode = 3, H(), tt("scroll", B, !0)
				}
			}, {
				_: function() {
					g = K.now(), c.elements = e.getElementsByClassName(p.lazyClass), d = e.getElementsByClassName(p.lazyClass + " " + p.preloadClass), tt("scroll", H, !0), tt("resize", H, !0), t.MutationObserver ? new MutationObserver(H).observe(X, {
						childList: !0,
						subtree: !0,
						attributes: !0
					}) : (X[Y]("DOMNodeInserted", H, !0), X[Y]("DOMAttrModified", H, !0), setInterval(H, 999)), tt("hashchange", H, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function(t) {
						e[Y](t, H, !0)
					}), /d$|^c/.test(e.readyState) ? U() : (tt("load", U), e[Y]("DOMContentLoaded", H), te(U, 2e4)), c.elements.length ? (E(), tb._lsFlush()) : H()
				},
				checkElems: H,
				unveil: F,
				_aLSL: B
			}),
			t$ = (G = ty(function(t, e, i, a) {
				var s, r, l;
				if (t._lazysizesWidth = a, a += "px", t.setAttribute("sizes", a), ts.test(e.nodeName || ""))
					for (s = e.getElementsByTagName("source"), r = 0, l = s.length; r < l; r++) s[r].setAttribute("sizes", a);
				i.detail.dataAttr || tf(t, i.detail)
			}), V = function(t, e, i) {
				var a, s = t.parentNode;
				s && (i = tg(t, s, i), (a = tu(t, "lazybeforesizes", {
					width: i,
					dataAttr: !!e
				})).defaultPrevented || (i = a.detail.width) && i !== t._lazysizesWidth && G(t, s, a, i))
			}, {
				_: function() {
					W = e.getElementsByClassName(p.autosizesClass), tt("resize", Q)
				},
				checkElems: Q = tv(function() {
					var t, e = W.length;
					if (e)
						for (t = 0; t < e; t++) V(W[t])
				}),
				updateElem: V
			}),
			t8 = function() {
				t8.i || (t8.i = !0, t$._(), tw._())
			};
		return c = {
			cfg: p,
			autoSizer: t$,
			loader: tw,
			init: t8,
			uP: tf,
			aC: tc,
			rC: tp,
			hC: tn,
			fire: tu,
			gW: tg,
			rAF: tb
		}
	}
}), function(t, e) {
	var i = function() {
		e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0)
	};
	e = e.bind(null, t, t.document), "object" == typeof module && module.exports ? e(require("lazysizes")) : t.lazySizes ? i() : t.addEventListener("lazyunveilread", i, !0)
}(window, function(t, e, i) {
	"use strict";

	function a(t, i, a) {
		var s, o, n, c, p = 0,
			d = 0,
			u = a;
		if (t) {
			if ("container" === i.ratio) {
				for (p = u.scrollWidth, d = u.scrollHeight; !(p && d || u === e);) p = (u = u.parentNode).scrollWidth, d = u.scrollHeight;
				p && d && (i.ratio = d / p)
			}(t = (s = t, o = i, n = [], c = function(t, e) {
				return f[typeof o[e]] ? o[e] : t
			}, n.srcset = [], o.absUrl && ($.setAttribute("href", s), s = $.href), s = ((o.prefix || "") + s + (o.postfix || "")).replace(h, c), o.widths.forEach(function(t) {
				var e = o.widthmap[t] || t,
					i = o.aspectratio || o.ratio,
					a = !o.aspectratio && l.traditionalRatio,
					r = {
						u: s.replace(b, e).replace(y, i ? a ? Math.round(t * i) : Math.round(t / i) : ""),
						w: t
					};
				n.push(r), n.srcset.push(r.c = r.u + " " + t + "w")
			}), n)).isPicture = i.isPicture, T && "IMG" == a.nodeName.toUpperCase() ? a.removeAttribute(r.srcsetAttr) : a.setAttribute(r.srcsetAttr, t.srcset.join(", ")), Object.defineProperty(a, "_lazyrias", {
				value: t,
				writable: !0
			})
		}
	}

	function s(t) {
		return t.getAttribute(t.getAttribute("data-srcattr") || l.srcAttr) || t.getAttribute(r.srcsetAttr) || t.getAttribute(r.srcAttr) || t.getAttribute("data-pfsrcset") || ""
	}
	var r, l, o, n, c, p, d, u, f = {
			string: 1,
			number: 1
		},
		m = /^\-*\+*\d+\.*\d*$/,
		g = /^picture$/i,
		b = /\s*\{\s*width\s*\}\s*/i,
		y = /\s*\{\s*height\s*\}\s*/i,
		h = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
		v = /^\[.*\]|\{.*\}$/,
		w = /^(?:auto|\d+(px)?)$/,
		$ = e.createElement("a"),
		x = e.createElement("img"),
		T = "srcset" in x && !("sizes" in x),
		z = !!t.HTMLPictureElement && !T;
	(function() {
		var e, a = {
			prefix: "",
			postfix: "",
			srcAttr: "data-src",
			absUrl: !1,
			modifyOptions: function() {},
			widthmap: {},
			ratio: !1,
			traditionalRatio: !1,
			aspectratio: !1
		};
		for (e in (r = i && i.cfg || t.lazySizesConfig) || (r = {}, t.lazySizesConfig = r), r.supportsType || (r.supportsType = function(t) {
				return !t
			}), r.rias || (r.rias = {}), "widths" in (l = r.rias) || (l.widths = [], function(t) {
				for (var e, i = 0; !e || e < 3e3;)(i += 5) > 30 && (i += 1), e = 36 * i, t.push(e)
			}(l.widths)), a) e in l || (l[e] = a[e])
	})(), addEventListener("lazybeforesizes", function(e) {
		if (e.detail.instance == i) {
			var o, n, c, p, d, u, f, y, $, x, T, _, k, C, L, P;
			if (o = e.target, e.detail.dataAttr && !e.defaultPrevented && !l.disabled && ($ = o.getAttribute(r.sizesAttr) || o.getAttribute("sizes")) && w.test($)) {
				if (n = s(o), c = (C = o, P = function e(i, a) {
						var s, r, o, n, c = t.getComputedStyle(i);
						for (s in n = {
								isPicture: !(!(r = i.parentNode) || !g.test(r.nodeName || ""))
							}, o = function(t, e) {
								var a = i.getAttribute("data-" + t);
								if (!a) {
									var s = c.getPropertyValue("--ls-" + t);
									s && (a = s.trim())
								}
								if (a) {
									if ("true" == a) a = !0;
									else if ("false" == a) a = !1;
									else if (m.test(a)) a = parseFloat(a);
									else if ("function" == typeof l[t]) a = l[t](i, a);
									else if (v.test(a)) try {
										a = JSON.parse(a)
									} catch (r) {}
									n[t] = a
								} else t in l && "function" != typeof l[t] ? n[t] = l[t] : e && "function" == typeof l[t] && (n[t] = l[t](i, a))
							}, l) o(s);
						return a.replace(h, function(t, e) {
							e in n || o(e, !0)
						}), n
					}(C, L = n), l.modifyOptions.call(C, {
						target: C,
						details: P,
						detail: P
					}), i.fire(C, "lazyriasmodifyoptions", P), P), T = b.test(c.prefix) || b.test(c.postfix), c.isPicture && (p = o.parentNode))
					for (d = p.getElementsByTagName("source"), u = 0, f = d.length; u < f; u++)(T || b.test(y = s(d[u]))) && (a(y, c, d[u]), _ = !0);
				T || b.test(n) ? (a(n, c, o), _ = !0) : _ && ((k = []).srcset = [], k.isPicture = !0, Object.defineProperty(o, "_lazyrias", {
					value: k,
					writable: !0
				})), _ && (z ? o.removeAttribute(r.srcAttr) : "auto" != $ && A({
					target: o,
					detail: x = {
						width: parseInt($, 10)
					}
				}))
			}
		}
	}, !0);
	var A = (o = function(t, e) {
		return t.w - e.w
	}, n = function(t) {
		for (var e, i, a = t.length, s = t[a - 1], r = 0; r < a; r++)
			if ((s = t[r]).d = s.w / t.w, s.d >= t.d) {
				!s.cached && (e = t[r - 1]) && e.d > t.d - .13 * Math.pow(t.d, 2.2) && (i = Math.pow(e.d - .6, 1.6), e.cached && (e.d += .15 * i), e.d + (s.d - t.d) * i > t.d && (s = e));
				break
			} return s
	}, c = function(t, e) {
		var a;
		return !t._lazyrias && i.pWS && (a = i.pWS(t.getAttribute(r.srcsetAttr || ""))).length && (Object.defineProperty(t, "_lazyrias", {
			value: a,
			writable: !0
		}), e && t.parentNode && (a.isPicture = "PICTURE" == t.parentNode.nodeName.toUpperCase())), t._lazyrias
	}, p = function(e) {
		var a = t.devicePixelRatio || 1;
		return Math.min(i.getX && i.getX(e) || a, 2.4, a)
	}, d = function(e, i) {
		var a, s, r, l, d, u;
		if ((d = e._lazyrias).isPicture && t.matchMedia) {
			for (s = 0, r = (a = e.parentNode.getElementsByTagName("source")).length; s < r; s++)
				if (c(a[s]) && !a[s].getAttribute("type") && (!(l = a[s].getAttribute("media")) || (matchMedia(l) || {}).matches)) {
					d = a[s]._lazyrias;
					break
				}
		}
		return (!d.w || d.w < i) && (d.w = i, d.d = p(e), u = n(d.sort(o))), u
	}, u = function(a) {
		if (a.detail.instance == i) {
			var s, l = a.target;
			if (!T && (t.respimage || t.picturefill || lazySizesConfig.pf)) return void e.removeEventListener("lazybeforesizes", u);
			("_lazyrias" in l || a.detail.dataAttr && c(l, !0)) && (s = d(l, a.detail.width)) && s.u && l._lazyrias.cur != s.u && (l._lazyrias.cur = s.u, s.cached = !0, i.rAF(function() {
				l.setAttribute(r.srcAttr, s.u), l.setAttribute("src", s.u)
			}))
		}
	}, z ? u = function() {} : addEventListener("lazybeforesizes", u), u)
})), "undefined" != typeof theme && theme.hasOwnProperty("settings") && (theme.settings.predictiveSearchEnabled = !1);
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		loadProductFirst: !1,
		showPlaceholderProductList: !0,
		placeholderProductPerRow: 3,
		placeholderProductGridItemClass: "boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-3 boost-pfs-filter-grid-width-mb-2",
		enableOTP: !0,
		aspect_ratio: boostPFSThemeConfig.custom.aspect_ratio,
		cropImagePossitionEqualHeight: boostPFSThemeConfig.custom.product_img_crop,
		defaultDisplay: boostPFSThemeConfig.custom.product_item_type,
		selectOptionContainer: ".boost-pfs-filter-product-item-image"
	},
	selector: {
		otpButtons: ".boost-pfs-filter-product-item-image"
	}
};
! function() {
	var t = !1,
		e = !1,
		i = !1,
		a = [],
		s = {},
		r = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
		l = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];

	function o(r) {
		if (e = !r.available, t = r.compare_at_price_min > r.price_min, i = r.price_min != r.price_max, a = r.images_info, s = r.variants[0], null !== Utils.getParam("variant") && "" != Utils.getParam("variant")) {
			var l = r.variants.filter(function(t) {
				return t.id == Utils.getParam("variant")
			});
			void 0 !== l[0] && (s = l[0])
		} else
			for (var o = 0; o < r.variants.length; o++)
				if (r.variants[o].available) {
					s = r.variants[o];
					break
				} return r
	}

	function n(t) {
		for (var e = "", i = "", s = l, o = 100, n = "", c = "", p = t.title, d = "", u = !Utils.isMobile() && a.length > 1 && boostPFSThemeConfig.custom.hasOwnProperty("active_image_swap") && !0 == boostPFSThemeConfig.custom.active_image_swap, f = 0; f < s.length; f++) n += Utils.getFeaturedImage(a, s[f] + "x") + " " + s[f] + "w", c += s[f], u && (d += Utils.optimizeImage(a[1].src, s[f] + "x") + " " + s[f] + "w"), f < s.length - 1 && (n += ", ", c += ", ", u && (d += ", "));
		return a.length > 0 && (o = 1 / (i = a[0].width / a[0].height) * 100), e += '<a href="{{itemUrl}}" class="boost-pfs-filter-product-item-image-link" ', e += 'style="padding-top:' + o + '%;">', e += '<img class="boost-pfs-filter-product-item-main-image lazyload Image--lazyLoad"data-srcset="' + n + '" data-src="' + Utils.getFeaturedImage(a, s[2] + "x") + '" data-widths="[' + c + ']" data-sizes="auto" src="' + r + '" alt="' + p + '"  ', u && (e += ' data-img-flip-src="' + Utils.optimizeImage(a[1].src, s[2] + "x") + '" data-img-flip-srcset="' + d + '" '), e += "/></a>"
	}

	function c(t) {
		var e = "";
		return boostPFSThemeConfig.custom.hasOwnProperty("show_vendor") && !0 == boostPFSThemeConfig.custom.show_vendor && (e = boostPFSTemplate.vendorHtml), e
	}

	function p(e) {
		var a = "";
		let s = document.querySelector(".js-vat-percentage").value;
		return boostPFSThemeConfig.custom.hasOwnProperty("show_price") && boostPFSThemeConfig.custom.show_price && (a = '<p class="boost-pfs-filter-product-item-price flex flex-row gap-2 !pb-0 items-center w-full">', t ? (tax_percentage = 100 - s, ex_vat_price = e.price_min * tax_percentage / 100, ex_vat_compared_price = e.compare_at_price_min * tax_percentage / 100, a += '<span class="boost-pfs-filter-product-item-sale-price js-inc-vat">' + Utils.formatMoney(e.price_min) + "</span>", a += '<s class="js-inc-vat">' + Utils.formatMoney(e.compare_at_price_min) + '</s><span class="js-inc-vat text-xs text-primary min-w-max">(' + incVat + ")</span>", a += '<span class="boost-pfs-filter-product-item-sale-price js-ex-vat">' + Utils.formatMoney(ex_vat_price) + "</span>", a += '<s class="js-ex-vat">' + Utils.formatMoney(ex_vat_compared_price) + '</s><span class="js-ex-vat text-xs text-primary min-w-max">(' + exVat + ")</span>") : (i && (a += '<span class="boost-pfs-filter-product-item-pr ice-from-text">' + boostPFSThemeConfig.label_basic.from + " </span>"), tax_percentage = 100 - s, ex_vat_price = e.price_min * tax_percentage / 100, a += '<span class="boost-pfs-filter-product-item-regular-price js-inc-vat">' + Utils.formatMoney(e.price_min) + '</span><span class="js-inc-vat vatText text-xs text-primary min-w-max">(' + incVat + ")</span>", a += '<span class="boost-pfs-filter-product-item-regular-price js-ex-vat">' + Utils.formatMoney(ex_vat_price) + '</span><span class="js-ex-vat vatText text-xs text-primary min-w-max">(' + exVat + ")</span>"), a += "</p>"), a
	}

	function d(i) {
		var a = "";
		boostPFSThemeConfig.custom.hasOwnProperty("sold_out_enable") && boostPFSThemeConfig.custom.sold_out_enable && e && (a = boostPFSTemplate.soldOutLabelHtml.replace(/{{style}}/g, ""));
		var s = "",
			r = "";
		return boostPFSThemeConfig.custom.sale_label_enable && t && !e && ("sale_percent" == boostPFSThemeConfig.custom.sale_label_display && (r = Math.round((i.compare_at_price_min - i.price_min) * 100 / i.compare_at_price_max)), s = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, ""), s = boostPFSTemplate.saleLabelHtml.replace(/percent/g, "-" + r + "%")), a + s
	}

	function u(t, e) {
		if (!boostPFSThemeConfig.custom.tag_label_enable) return "";
		if (console.log(t.tags), e) {
			var i = "";
			if (t.tags)
				for (var a = 0; a < t.tags.length; a++) {
					var s = t.tags[a];
					if (-1 !== s.indexOf("pfs:label")) {
						var r = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, s.split("pfs:label-")[1].replace(/\s/g, "-").toLowerCase()).replace(/{{labelTagTitle}}/g, s.split("pfs:label-")[1]);
						i += r
					}
				}
		} else {
			var i = "";
			if (t.tags) {
				for (var a = t.tags.length - 1; a >= 0; a--)
					if (-1 !== (s = t.tags[a]).indexOf("pfs:label")) {
						var r = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, s.split("pfs:label-")[1].replace(/\s/g, "-").toLowerCase()).replace(/{{labelTagTitle}}/g, s.split("pfs:label-")[1]);
						i += r;
						break
					}
			}
		}
		return i
	}

	function f(t, e, i) {
		return i.indexOf(t) === e
	}

	function m(t) {
		var e = "";
		if (boostPFSThemeConfig.custom.swatch_enable)
			for (var i = ["color", "img", "pro_img", "text"], a = 0; a < i.length; a++) {
				// Skip color swatches if product doesn't have Swatch__Colour__ tag
				if (i[a] === "color" && (!t.tags || !t.tags.includes("Swatch__Colour__"))) continue;
				for (var s = boostPFSThemeConfig.custom["swatch_by_" + i[a] + "_apply"].split(",").filter(f), r = boostPFSThemeConfig.custom["swatch_by_" + i[a] + "_shape"], l = i[a], o = 0; o < s.length; o++) {
					var n = s[o].trim(),
						c = n,
						p = [],
						d = 0,
						u = [],
						m = 4,
						g = Utils.getFeaturedImage(t.images_info, "360x"),
						b = "#ffffff",
						y = "",
						h = "More " + c;
					if (void 0 !== t.options_with_values && t.options_with_values.length > 0 && (p = t.options_with_values.filter(function(t) {
							return t.name == n
						})).length > 0) {
						m > (d = p[0].values.length) && (m = d), u = p[0].values, e += '<ul class="boost-pfs-filter-item-swatch boost-pfs-filter-item-swatch-option' + n + " boost-pfs-filter-item-swatch-shape-" + r + " boost-pfs-filter-item-swatch-type-" + l + '">';
						for (var v = 0; v < m; v++) {
							if (b = u[v].title, swatchVariant = t.variants[v], "" != (sImageIndex = u[v].image || "") && (g = Utils.optimizeImage(swatchVariant.image, "360x") + " 360w"), l) switch (l) {
								case "img":
									y = boostPFSAppConfig.general.file_url.replace(/\?/, Utils.slugify(c).replace(/\-/g, "_") + "-" + Utils.slugify(b) + ".png?v=");
									break;
								case "pro_img":
									y = Utils.getFeaturedImage(t.images_info, "50x"), "" != sImageIndex && (y = Utils.optimizeImage(t.images[sImageIndex], "50x")), y && y.includes("boost-pfs-no-image") && (y = "");
									break;
								default:
									y = ""
							}
							e += "<li>", "text" == l ? e += '<a aria-label="' + n + ": " + b + '" title="' + b + '" href="' + Utils.buildProductItemUrl(t) + "?variant=" + swatchVariant.id + '">' + b + "</a>" : (boostPFSThemeConfig.custom.show_swatch_tooltip && (e += '<div class="boost-pfs-product-item-tooltip">' + b + "</div>"), e += '<span tabindex="0" aria-label="' + n + ": " + b + '" style="background-color: ' + b + "; ", "" != y ? e += "background-image: url(" + y + ');" ' : e += '" ', "" != g && (e += 'data-img="' + g + '" '), e += "></span>"), e += "</li>"
						}
						d > m && (e += '<li class="boost-pfs-filter-item-swatch-more">', e += '<a href="{{itemUrl}}" aria-label="' + h + '" title="' + h + '">+' + (d - m) + "</a>", e += "</li>"), e += "</ul>"
					}
				}
			}
		return e
	}

	function g(t) {
		var e = "";
		return boostPFSThemeConfig.custom.hasOwnProperty("show_product_review") && !0 == boostPFSThemeConfig.custom.show_product_review && (e = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>'), e
	}

	function b(t) {
		return !Utils.isMobile() && a.length > 1 && boostPFSThemeConfig.custom.hasOwnProperty("active_image_swap") && !0 == boostPFSThemeConfig.custom.active_image_swap ? "has-bc-swap-image" : ""
	}

	function y(t, e) {
		return "" === t ? t : "list" === t ? Labels.listView || "List view" : void 0 === e || 0 === e ? Labels.gridView || "Grid view" : (Labels.gridViewColumns || "Grid view {{ count }} Columns").replace(/{{ count }}/g, e)
	}
	BoostPFS.inject(this), boostPFSFilterConfig.general.separateRefineByFromFilter = !!jQ(".boost-pfs-filter-tree-h").length && !Utils.isMobile() > 0 && "style-expand" != boostPFSThemeConfig.custom.filter_tree_horizontal_style, Selector.stickyElementDesktop = jQ(".boost-pfs-filter-left-col").length > 0 && !Utils.isMobile() ? ".boost-pfs-filter-left-col" : ".boost-pfs-filter-tree", ProductGridItem.prototype.compileTemplate = function(i) {
		i || (i = this.data), i = o(i);
		var a, r, l, f, y, h, v, w, $, x, T = boostPFSTemplate.productGridItemHtml,
			z = e ? boostPFSTemplate.soldOutClass : "",
			A = t ? boostPFSTemplate.saleClass : "";
		let _;
		return T = (T = (T = (T = (T = (T = (T = T.replace(/{{soldOutClass}}/g, z)).replace(/{{saleClass}}/g, A)).replace(/{{gridWidthClass}}/g, function t() {
			var e = "";
			switch (boostPFSThemeConfig.custom.products_per_row) {
				case 2:
					e = "boost-pfs-filter-grid-width-2";
					break;
				case 3:
					e = "boost-pfs-filter-grid-width-3";
					break;
				case 5:
					e = "boost-pfs-filter-grid-width-5";
					break;
				case 6:
					e = "boost-pfs-filter-grid-width-6";
					break;
				default:
					e = "boost-pfs-filter-grid-width-4"
			}
			switch (boostPFSThemeConfig.custom.products_per_row_m) {
				case 1:
					e += " boost-pfs-filter-grid-width-mb-1";
					break;
				case 3:
					e += " boost-pfs-filter-grid-width-mb-3";
					break;
				default:
					e += " boost-pfs-filter-grid-width-mb-2"
			}
			return e
		}(i))).replace(/{{itemLabels}}/g, d(i))).replace(/{{itemTagLabels}}/g, u(i, !0))).replace(/{{itemImages}}/g, n(i))).replace(/{{itemPrice}}/g, p(i)), "undefined" != typeof Integration && ("undefined" == typeof Integration || "function" != typeof Integration.hascompileTemplate || Integration.hascompileTemplate("reviews")) || (T = T.replace(/{{itemReviews}}/g, g(i))), T = (T = (T = (T = (T = (T = (T = (T = (T = (T = (T = (T = (T = T.replace(/{{itemVendor}}/g, c(i))).replace(/{{itemForm}}/g, (h = i, v = '<form method="post" action="/cart/add" id="product-form-' + h.id + '" accept-charset="UTF-8" class="flex flex-col gap-2 mt-2" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">', v += '<input type="hidden" name="form_type" value="product">', v += '<input type="hidden" name="utf8" value="✓">', v += '<input type="hidden" class="single-variant" name="id" value="' + s.id + '"/>', v += '<div class="js-prod-btn-group max-h-[42px] flex w-full">', v += (w = "", w += '<div class="quantity-selector flex border bg-white border-grey-100 mr-2.5 py-2 px-6 box-border rounded-3xl" data-max-quantity="' + document.querySelector(".js-quantity-max").value + ' "data-variant-id="' + s.id + '">', w += '<button type="button" disabled class="js-btn-quantity minus-button greyed flex items-center justify-center cursor-not-allowed">', w += '<span aria-hidden="true" class="flex relative w-3 h-3 items-center text-black">', w += iconMinus, w += "</span>", w += "</button>", w += '<input type="number" id="quantity" class="js-input-quantity !pointer-events-none !py-0 w-auto border-none !px-3 text-black text-center text-sm !bg-white input-quantity focus:!ring-0" name="quantity" aria-label="Product Quantity" value="1" min="1"/>', w += '<button type="button" class="js-btn-quantity plus-button flex items-center justify-center">', w += '<span aria-hidden="true" class="flex relative w-3 h-3 items-center text-black">', w += iconPlus, w += "</span>", w += "</button>", w += "</div>"), v += function t(e) {
			var i = "";
			if (-1 !== window.location.href.indexOf("urban")) var a = "btn js-btn-add-to-cart btn-primary bg-primary-hover hover:bg-primary w-full";
			else var a = "btn js-btn-add-to-cart btn-primary w-full";
			if (e.metafields[0] && null !== e.metafields[0].value) var s = e.metafields[0].value;
			return e.metafields[0] && null !== e.metafields[0].value ? (i += '<button type="submit" name="add" class="' + a + '" data-preorder-attr="' + s + '">', i += window.product.preOrder, i += "</button>") : (i += '<button type="submit" name="add" class="' + a + '">', i += window.product.addToCart + iconAddBag, i += "</button>"), i
		}(h), v += "</div>", v += "</form>"))).replace(/{{itemSavings}}/g, ($ = i, x = "", a = "1." + document.querySelector(".js-vat-percentage").value, vat_price = $.price_min, vat_compared_price = $.compare_at_price_min, ex_vat_price = vat_price / a, ex_vat_compared_price = vat_compared_price / a, vat_sale_price = vat_compared_price - vat_price, ex_vat_sale_price = ex_vat_compared_price - ex_vat_price, boostPFSThemeConfig.custom.hasOwnProperty("show_price") && boostPFSThemeConfig.custom.show_price && (x = "", t && (x += '<span class="js-inc-vat price-savings relative bg-secondary h-max flex max-w-max mr-4 py-1 items-center text-white text-sm px-2 rounded-[20px] transition ease-in-out duration-300">Save ' + Utils.formatMoney(vat_sale_price) + "</span>", x += '<span class="js-ex-vat price-savings relative bg-secondary h-max flex max-w-max mr-4 py-1 items-center text-white text-sm px-2 rounded-[20px] transition ease-in-out duration-300">Save ' + Utils.formatMoney(ex_vat_sale_price) + "</span>")), x))).replace(/{{productGroup}}/g, function t(e) {
			var i = "";
			// Only set colour group if product has a tag starting with Swatch__Colour__
			var hasSwatchTag = e.tags.length > 0 && e.tags.some(function(tag) { return tag.indexOf("Swatch__Colour__") === 0; });
			if (hasSwatchTag)
				for (var a = 0; a < e.tags.length; a++) {
					var s = e.tags[a];
					if (s.includes("group__")) {
						i = 'data-colour-group="' + s + '"';
						break
					}
				}
			return i
		}(i))).replace(/{{currentID}}/g, (r = i, l = "", null !== r.id && (l = 'data-current-product-id="' + r.id + '"'), l))).replace(/{{itemStockIndicator}}/g, (f = i, y = "", f.metafields[0] && null !== f.metafields[0].value ? (stockIconClass = "bg-red", stockText = window.stock.outOfStock) : (stockIconClass = "bg-green", stockText = window.stock.inStock), y += '<div class="availability relative flex items-center text-sm max-w-fit text-primary leading-[18px]">', y += '<span class="relative w-2.5 h-2.5 rounded-full mr-2 ' + stockIconClass + '"></span>', y += stockText, y += "</div>"))).replace(/{{itemActiveSwapClass}}/g, b(i))).replace(/{{itemSwatches}}/g, m(i))).replace(/{{itemId}}/g, i.id)).replace(/{{itemTitle}}/g, i.title)).replace(/{{itemHandle}}/g, i.handle)).replace(/{{itemVendorLabel}}/g, i.vendor)).replace(/{{itemUrl}}/g, "/products/" + i.handle)
	}, ProductListItem.prototype.compileTemplate = function(a) {
		a || (a = this.data), a = o(a);
		var s = boostPFSTemplate.productListItemHtml,
			r = e ? boostPFSTemplate.soldOutClass : "",
			l = t ? boostPFSTemplate.saleClass : "";
		s = (s = (s = (s = (s = s.replace(/{{soldOutClass}}/g, r)).replace(/{{saleClass}}/g, l)).replace(/{{itemLabels}}/g, d(a))).replace(/{{itemTagLabels}}/g, u(a, !1))).replace(/{{itemImages}}/g, n(a)), "undefined" != typeof Integration && ("undefined" == typeof Integration || "function" != typeof Integration.hascompileTemplate || Integration.hascompileTemplate("reviews")) || (s = s.replace(/{{itemReviews}}/g, g(a))), s = s.replace(/{{itemVendor}}/g, c(a));
		var f = p(a, t, i);
		s = s.replace(/{{itemPrice}}/g, f);
		var y = "";
		if (null != a.body_html) {
			var y = jQ("<p>" + a.body_html + "</p>").text();
			y = y.split(" ").length > 35 ? y.split(" ").splice(0, 35).join(" ") + "..." : y.split(" ").splice(0, 35).join(" ")
		}
		return (s = (s = (s = (s = (s = (s = s.replace(/{{itemDescription}}/g, y)).replace(/{{itemActiveSwapClass}}/g, b(a))).replace(/{{itemSwatches}}/g, m(a))).replace(/{{itemTitle}}/g, a.title)).replace(/{{itemVendorLabel}}/g, a.vendor)).replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(a))).replace(/{{itemId}}/g, a.id)
	}, ProductPaginationDefault.prototype.compileTemplate = function(t) {
		t || (t = this.totalProduct);
		var e = parseInt(Utils.stripHtml(Globals.queryParams.page)),
			i = Math.ceil(t / Utils.stripHtml(Globals.queryParams.limit));
		if ((!e || isNaN(e)) && (e = 1), i <= 1) return "";
		var a = boostPFSTemplate.paginateHtml,
			s = e > 1 ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		s = s.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", e, e - 1)), a = a.replace(/{{previous}}/g, s);
		var r = e < i ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		r = r.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", e, e + 1)), a = a.replace(/{{next}}/g, r);
		for (var l = [], o = e - 1; o > e - 3 && o > 0; o--) l.unshift(o);
		e - 4 > 0 && l.unshift("..."), e - 4 >= 0 && l.unshift(1), l.push(e);
		for (var n = [], c = e + 1; c < e + 3 && c <= i; c++) n.push(c);
		e + 3 < i && n.push("..."), e + 3 <= i && n.push(i);
		for (var p = "", d = l.concat(n), u = 0; u < d.length; u++) "..." == d[u] ? p += boostPFSTemplate.pageItemRemainHtml : p += d[u] == e ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml, p = (p = p.replace(/{{itemTitle}}/g, d[u])).replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", e, d[u]));
		return a.replace(/{{pageItems}}/g, p)
	}, ProductSorting.prototype.compileTemplate = function() {
		var t = boostPFSTemplate.sortingHtml;
		if (boostPFSThemeConfig.custom.show_sort_by && boostPFSTemplate.hasOwnProperty("sortingHtml")) {
			var e = Utils.getSortingList();
			if (e) {
				var i = Utils.stripHtml(Globals.queryParams.sort) || "",
					a = "";
				for (var s in e) activeClass = "", i == s && (activeClass = "boost-pfs-filter-sort-item-active"), a += '<li aria-label="' + e[s] + '"><a href="#" data-sort="' + s + '" class="' + activeClass + '"  title="' + e[s] + '" aria-label="' + e[s] + '">' + e[s] + "</a></li>";
				t = (t = t.replace(/{{sortingItems}}/g, a)).replace(/{{sortingLabel}}/g, Labels.sorting)
			}
		}
		return t
	}, ProductSorting.prototype.render = function() {
		jQ(Selector.topSorting).html(this.compileTemplate()), jQ(".boost-pfs-filter-custom-sorting").hasClass("boost-pfs-filter-sort-active") && jQ(".boost-pfs-filter-custom-sorting").toggleClass("boost-pfs-filter-sort-active");
		var t = "",
			e = Utils.stripHtml(Globals.queryParams.sort) || "",
			i = Utils.getSortingList();
		t = e.length > 0 && i && i[e] ? i[e] : Labels.sorting_heading, jQ(".boost-pfs-filter-custom-sorting button span span").text(t)
	}, ProductSorting.prototype.bindEvents = function() {
		jQ(".boost-pfs-filter-filter-dropdown a").click(function(t) {
			t.preventDefault(), FilterApi.setParam("sort", jQ(this).data("sort")), FilterApi.setParam("page", 1), FilterApi.applyFilter("sort")
		}), jQ(".boost-pfs-filter-custom-sorting > button").click(function() {
			jQ(".boost-pfs-filter-filter-dropdown").toggle().parent().toggleClass("boost-pfs-filter-sort-active")
		}), jQ(Selector.filterTreeMobileButton).click(function() {
			jQ(".boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown").hide()
		}), jQ(document).on("click", function(t) {
			0 === jQ(t.target).parents(".boost-pfs-filter-top-sorting").find(".boost-pfs-filter-filter-dropdown").length && jQ(".boost-pfs-filter-filter-dropdown").hide().parent().removeClass("boost-pfs-filter-sort-active")
		})
	}, ProductDisplayType.prototype.compileTemplate = function() {
		var t = "<span>" + boostPFSThemeConfig.label.toolbar_viewas + "</span>";
		return "grid" == boostPFSThemeConfig.custom.product_item_type ? "view_as_type_list_grid_multi_col" != boostPFSThemeConfig.custom.view_as_type || Utils.isMobile() ? (t += '<a href="' + Utils.buildToolbarLink("display", "list", "grid") + '" title="' + y("grid") + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>', t += '<a href="' + Utils.buildToolbarLink("display", "grid", "list") + '" title="' + y("list") + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>') : (t += '<a href="' + Utils.buildToolbarLink("display", "grid", "list") + '" title="' + y("list") + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>', t += '<a href="' + Utils.buildToolbarLink("display", "list", "grid") + '" title="' + y("grid", 2) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>', t += '<a href="' + Utils.buildToolbarLink("display", "list", "grid") + '" title="' + y("grid", 3) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3" data-view="grid-3"><span class="icon-fallback-text"></span></a>', t += '<a href="' + Utils.buildToolbarLink("display", "list", "grid") + '" title="' + y("grid", 4) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>', t += '<a href="' + Utils.buildToolbarLink("display", "list", "grid") + '" title="' + y("grid", 5) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>', t += '<a href="' + Utils.buildToolbarLink("display", "list", "grid") + '" title="' + y("grid", 6) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text"></span></a>') : "view_as_type_list_grid_multi_col" != boostPFSThemeConfig.custom.view_as_type || Utils.isMobile() ? (t += '<a href="' + Utils.buildToolbarLink("display", "grid", "list") + '" title="' + y("list") + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>', t += '<a href="' + Utils.buildToolbarLink("display", "list", "grid") + '" title="' + y("grid") + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>') : (t += '<a href="' + Utils.buildToolbarLink("display", "grid", "list") + '" title="' + y("list") + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>', t += '<a href="' + Utils.buildToolbarLink("display", "list", "grid") + '" title="' + y("grid", 2) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>', t += '<a href="' + Utils.buildToolbarLink("display", "list", "grid") + '" title="' + y("grid", 3) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3" data-view="grid-3"><span class="icon-fallback-text"></span></a>', t += '<a href="' + Utils.buildToolbarLink("display", "list", "grid") + '" title="' + y("grid", 4) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>', t += '<a href="' + Utils.buildToolbarLink("display", "list", "grid") + '" title="' + y("grid", 5) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>', t += '<a href="' + Utils.buildToolbarLink("display", "list", "grid") + '" title="' + y("grid", 6) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text"></span></a>'), t = t.replace(/{{class.productDisplayType}}/g, Class.productDisplayType)
	};
	var h = ProductDisplayType.prototype.render;

	function v(t, e) {
		var i = RegExp("\\b" + e + "[^ ]*[ ]?\\b", "g");
		return t.className = t.className.replace(i, ""), t
	}
	ProductDisplayType.prototype.render = function() {
		if (h.call(this), this.$element.length) {
			if (this.$element.find(this.selector.productDisplayTypeList).removeClass("active"), this.$element.find(this.selector.productDisplayTypeGrid).removeClass("active"), "list" == Utils.stripHtml(Globals.queryParams.display)) this.$element.find(this.selector.productDisplayTypeList).addClass("active");
			else if ("grid" == Utils.stripHtml(Globals.queryParams.display)) {
				if ("view_as_type_list_grid_multi_col" != boostPFSThemeConfig.custom.view_as_type || Utils.isMobile()) this.$element.find(this.selector.productDisplayTypeGrid).addClass("active");
				else {
					var t = boostPFSThemeConfig.custom.products_per_row;
					this.$element.find(this.selector.productDisplayTypeGrid).each(function() {
						var e = jQ(this).parent(),
							i = jQ(".boost-pfs-filter-top-display-type").attr("class").split(" "),
							a = i[i.length - 1],
							s = a.split("-")[a.split("-").length - 1];
						if (e.hasClass("boost-pfs-filter-view-as-click") && jQ(this).data("view") == a) {
							if (jQ(this).addClass("active"), jQ(".boost-pfs-filter-product-item").length > 0) {
								for (var r = jQ(".boost-pfs-filter-product-item").attr("class").split(" "), l = "", o = 0; o < r.length; o++)
									if (r[o].match(/(^|\s)boost-pfs-filter-grid-width-\S+/g)) {
										l = r[o];
										break
									} jQ(".boost-pfs-filter-product-item").removeClass(l), jQ(".boost-pfs-filter-product-item").addClass("boost-pfs-filter-grid-width-" + s)
							}
						} else e.hasClass("boost-pfs-filter-view-as-click") && "history" != Globals.queryParams.event_type || jQ(this).data("view").split("-")[1] != t || jQ(this).addClass("active")
					})
				}
			}
		}
	}, ProductLimit.prototype.compileTemplate = function() {
		var t = "";
		if (boostPFSThemeConfig.custom.show_limit && boostPFSTemplate.hasOwnProperty("showLimitHtml")) {
			var e = Settings.getSettingValue("general.showLimitList");
			if ("" != e) {
				var i = "",
					a = e.split(",");
				for (var s in sortingArr) i += '<option value="' + a[s].trim() + '">' + a[s].trim() + "</option>";
				t = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, i)
			}
		}
		return t
	}, Breadcrumb.prototype.compileTemplate = function(t) {
		t || (t = this.collectionData);
		var e = "";
		if (boostPFSTemplate.hasOwnProperty("breadcrumbHtml")) {
			if (void 0 !== t && t.hasOwnProperty("collection")) {
				var i = t.collection;
				void 0 !== this.collectionTags && null !== this.collectionTags ? (e += boostPFSTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, "/collections/" + i.handle).replace(/{{itemTitle}}/g, i.title), e += " {{breadcrumbDivider}} ", e += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0])) : e += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, i.title)
			} else e += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, Settings.getSettingValue("label.defaultCollectionHeader"))
		}
		return e
	}, ProductList.prototype.afterRender = function(t) {
		t || (t = this.data), window.SPR && "function" == typeof window.SPR.initDomEls && "function" == typeof window.SPR.loadBadges && boostPFSThemeConfig.custom.show_product_review && (window.SPR.initDomEls(), window.SPR.loadBadges());
		document.querySelectorAll(".boost-pfs-filter-product-item").forEach(t => {
			let e = t.querySelector(".quantity-selector"),
				i = t.querySelector(".plus-button"),
				a = t.querySelector(".minus-button"),
				s = t.querySelector(".input-quantity");
			i.addEventListener("click", function() {
				let t = e.getAttribute("data-max-quantity"),
					r = parseInt(s.value) + 1;
				r <= t && (s.value = r, s.setAttribute("value", r), r == t && (i.classList.add("greyed"), i.classList.add("cursor-not-allowed"), i.setAttribute("disabled", !0)), a.classList.contains("greyed") && (a.classList.remove("greyed"), a.classList.remove("cursor-not-allowed"), a.removeAttribute("disabled")))
			}), a.addEventListener("click", function() {
				let t = parseInt(s.value) - 1;
				t >= 1 && (s.value = t, s.setAttribute("value", t), 1 == t && (a.classList.add("greyed"), a.classList.add("cursor-not-allowed"), a.setAttribute("disabled", !0)), i.classList.contains("greyed") && (i.classList.remove("greyed"), i.classList.remove("cursor-not-allowed"), i.removeAttribute("disabled")))
			}), s.addEventListener("input", function() {
				let t = document.querySelector(".js-quantity-max").value,
					e = parseInt(s.value);
				e <= t && (s.value = e, s.setAttribute("value", e)), 1 == e && (a.classList.add("greyed"), a.classList.add("cursor-not-allowed"), a.setAttribute("disabled", !0)), i.classList.contains("greyed") && (i.classList.remove("greyed"), i.classList.remove("cursor-not-allowed"), i.removeAttribute("disabled")), e >= t && (i.classList.add("greyed"), i.classList.add("cursor-not-allowed"), i.setAttribute("disabled", !0)), a.classList.contains("greyed") && (a.classList.remove("greyed"), a.classList.remove("cursor-not-allowed"), a.removeAttribute("disabled"))
			})
		}), document.querySelectorAll(".boost-pfs-filter-product-item").forEach(function(t) {
			var e = t.querySelector(".product-card-colours-container"),
				i = e.getAttribute("data-colour-group"),
				a = parseInt(e.getAttribute("data-current-product-id"));
			if (i) {
				var s = new XMLHttpRequest;
				s.onreadystatechange = function() {
					if (4 == this.readyState && 200 == this.status) {
						var t = this.responseText;
						if (t) try {
							var i = JSON.parse(t)
						} catch (s) {
							var i = null
						}
						i && function t(e, i, a) {
							var s = '<div class="product-colours">',
								r = [],
								l = [],
								o = Object.values(e.products);
							o.sort(function(t, e) {
								return parseInt(t.size) - parseInt(e.size)
							});
							for (var n = 0; n < o.length; n++) {
								var c = parseInt(o[n].id),
									p = o[n].colour,
									d = o[n].url,
									u = o[n].size,
									f = r.findIndex(t => t.colour === p);
								if (c === i) var m = p; - 1 == f && r.push({
									colour: p,
									url: d,
									size: u
								}), l.push({
									id: c,
									colour: p,
									url: d,
									size: u
								})
							}
							r.forEach(t => {
								let e = "btn-colour-swatch " + t.colour.toLowerCase() + " h-6 w-6 rounded-full border border-gray-100 mr-2.5 cursor-pointer";
								e.includes(m) && (e += " current"), s += '<a href="' + t.url + '" class="' + e + '"></a>'
							}), s += "</div>", a.querySelector(".title").insertAdjacentHTML("afterend", s)
						}(i, a, e)
					}
				}, s.open("GET", "/collections/all/" + i + "?view=swatch", !0), s.send()
			}
		})
	}, Filter.prototype.afterRender = function(t) {
		t || (t = this.data);
		var e, i = t.total_product + "<span> " + boostPFSThemeConfig.label.items_with_count_other + "</span>";
		1 == t.total_product && (i = t.total_product + "<span> " + boostPFSThemeConfig.label.items_with_count_one + "</span>");
		let a = document.querySelectorAll(".boost-pfs-filter-option-item-list .boost-pfs-filter-option-value");
		if (a.forEach(t => {
				t.textContent = t.textContent.replace(/["_]/g, " ")
			}), 0 == t.total_product ? jQ(".boost-pfs-filter-default-toolbar-inner").addClass("boost-pfs-filter-toolbar-product-0") : jQ(".boost-pfs-filter-default-toolbar-inner").removeClass("boost-pfs-filter-toolbar-product-0"), jQ(".boost-pfs-filter-total-product").html(i), jQ("body").find(".boost-pfs-filter-skeleton-button").remove(), /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && Utils.isMobile() && jQ(".boost-pfs-filter-product-item").find("a").on("touchstart", function() {
				isScrolling = !1
			}).on("touchmove", function() {
				isScrolling = !0
			}).on("touchend", function() {
				isScrolling || (window.location = jQ(this).attr("href"))
			}), function t(e) {
				if (!Utils.isMobile() && boostPFSThemeConfig.custom.hasOwnProperty("active_image_swap") && !0 == boostPFSThemeConfig.custom.active_image_swap) {
					var i = "",
						a = "",
						s = "",
						l = "",
						o = "";
					jQ(".boost-pfs-filter-product-item").each(function() {
						var t = jQ(this),
							e = t.find(".boost-pfs-filter-product-item-main-image");
						void 0 !== e.data("img-flip-src") && "" != e.data("img-flip-src") && (a = e.data("img-flip-src"), i = e.data("img-flip-srcset"), s = e.attr("alt"), o = '<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"data-srcset="' + i + '" data-src="' + a + '" data-widths="[' + (l = e.data("widths")) + ']" data-sizes="auto" src="' + r + '" alt="' + s + '" />', t.find(".boost-pfs-filter-product-item-image-link").append(o))
					})
				}
			}(t), "list" !== Utils.stripHtml(Globals.queryParams.display) && setTimeout(function() {
				$(t)
			}, 700), jQ(window).resize(function() {
				"list" !== Utils.stripHtml(Globals.queryParams.display) && setTimeout(function() {
					$(t)
				}, 700)
			}), "none" != boostPFSThemeConfig.custom.swatch_change_img && (e = boostPFSThemeConfig.custom.swatch_change_img, jQ(".boost-pfs-filter-item-swatch li span").each(function() {
				var t = jQ(this).parents(".boost-pfs-filter-product-item-inner").find(".boost-pfs-filter-product-item-main-image");
				"hover" == e && jQ(this).hover(function() {
					var e = jQ(this).data("img");
					t.attr("srcset", e)
				}), "click" == e && jQ(this).click(function() {
					var e = jQ(this).data("img");
					t.attr("srcset", e)
				}), jQ(this).focus(function() {
					if (jQ("body").hasClass("boost-pfs-ada")) {
						var e = jQ(this).data("img");
						t.attr("srcset", e)
					}
				})
			})), "function" == typeof x && x(jQ(Selector.products).find("[data-boost-image-loading-animation]")), boostPFSThemeConfig.custom.hasOwnProperty("layout_type") && "fullwidth" == boostPFSThemeConfig.custom.layout_type && !Utils.isMobile() && jQ("body").addClass("boost-pfs-filter-fullwidth-page"), document.addEventListener("scroll", function() {
				jQ(".boost-pfs-filter-tree-h.boost-pfs-filter-stick").length > 0 && jQ(window).width() > 767 && jQ(".boost-pfs-filter-custom-sorting .boost-pfs-filter-filter-dropdown").hide().parent().removeClass("boost-pfs-filter-sort-active")
			}), jQ(".site-nav__thumb-menu").length > 0 && Utils.isMobile()) {
			var s = jQ(".site-nav__thumb-menu").height() + 40;
			jQ(".boost-pfs-filter-tree-mobile-button-stick-wrapper").css("bottom", s).addClass("boost-pfs-filter-sticky-bottom"), jQ(".boost-pfs-filter-mobile-style1").addClass("boost-pfs-filter-mobile-style1-sticky-bottom")
		}
		let l = document.querySelector(".boost-pfs-filter-tree-mobile-button-label");
		l.innerHTML = "Sort & Filter"
	};
	var w = ProductDisplayType.prototype._onClickEvent;

	function $(t) {
		var e = -1,
			i = [],
			a = null;
		jQ(".boost-pfs-filter-product-item").each(function(t, s) {
			var r = jQ(s).offset().top;
			(!a || a.offset().top !== r) && (a = jQ(s), e++), i[e] || (i[e] = []), i[e].push(s)
		});
		for (var s = 0; s < i.length; s++) {
			var r = 0;
			i[s].length;
			for (var l = 0; l < i[s].length; l++) r = Math.max(r, jQ(i[s][l]).find(".boost-pfs-filter-product-bottom-inner").height());
			jQ(i[s]).find(".boost-pfs-filter-product-bottom-inner").css({
				"min-height": r
			})
		}
		var o = boostPFSFilterConfig.general.aspect_ratio;
		if ("false" != o) {
			var n = boostPFSFilterConfig.general.cropImagePossitionEqualHeight,
				c = jQ(".boost-pfs-filter-product-item").width();
			if ("false" != o && "auto" != o) {
				var p = 0,
					c = jQ(".boost-pfs-filter-product-item").width();
				if ("false" != o && "auto" != o && "other" != o) var d = boostPFSThemeConfig.custom.aspect_ratio;
				else var d = "";
				var u = boostPFSThemeConfig.custom.aspect_ratio_other;
				if ("" == u && "" == d) return null;
				"other" != o ? p = c * (d = parseInt((d = d.split(":"))[1]) / parseInt(d[0])) : "" != u && "other" == o && (p = c * (u = parseInt((u = u.split(":"))[1]) / parseInt(u[0]))), jQ(".boost-pfs-filter-product-item-image-link").css({
					"padding-top": p + "px"
				}).addClass("boost-pfs-filter-crop-image-position-" + n)
			}
		}
	}

	function x(t) {
		t.length && t.removeAttr("data-boost-image-loading-animation")
	}
	ProductDisplayType.prototype._onClickEvent = function(t) {
		if (w.call(this, t), "view_as_type_list_grid_multi_col" == boostPFSThemeConfig.custom.view_as_type && !Utils.isMobile()) {
			jQ(".boost-pfs-filter-top-display-type").addClass("boost-pfs-filter-view-as-click");
			var e = jQ(t.target).data("view");
			jQ(".boost-pfs-filter-top-display-type")[0].className = jQ(".boost-pfs-filter-top-display-type")[0].className.replace(/(^|\s)grid-\S+/g, ""), jQ(".boost-pfs-filter-top-display-type").addClass(e)
		}
	}, ProductListPlaceholder.prototype.render = function() {
		var t = this.settings.productsPerRow || this.settings.placeholderProductPerRow,
			e = this.compileTemplate();
		this.$element = [];
		for (var i = 0; i < t; i++) this.$element.push(jQ(e));
		this.isFetchedProductData ? this.setHide() : this.setShow()
	}, ProductListPlaceholder.prototype.compileTemplateExtra = function() {
		var t = boostPFSTemplate.productListPlaceholderHtml,
			e = parseFloat(this.settings.placeholderImageRatio);
		return t.replace(/{{class.filterProductSkeleton}}/g, Class.filterProductSkeleton).replace(/{{class.filterSkeleton}}/g, Class.filterSkeleton).replace(/{{class.filterSkeletonText}}/g, Class.filterSkeletonText).replace(/{{paddingTop}}/g, 100 * (e > 0 ? e : 1.4))
	}, Array.prototype.insert = function(t, e) {}, jQ(document).ready(function() {
		if (jQ(".mm-fixed-top").length > 0) {
			var t = jQ(".mm-fixed-top").height();
			jQ(".boost-pfs-filter-collection-header-wrapper").css("margin-top", t)
		}
	})
}();